import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { EditorEditComponent } from '../../../../editor/editor-edit/editor-edit.component';
import { CtBinaryOperator, CtButtonConfiguration, CtModelConfiguration, CTModelDatatableFilter, CtModelDatatableOperators, CtModelService, MAT_RAISED_PRIMARY, MAT_RAISED_WARN, SnackbarService } from '@ctsolution/ct-framework';
import { TinyMceSetupConfiguration } from '../../../../editor/tiny-mce.setup-configuration';
import { WorkOrderEditTemplateConfiguration } from './work-order-edit-template.configuration';
import { CtWebapiGenericResponse, CtWebapiService, DataRequest, MethodEnum } from '@ctsolution/ct-webapi';
import { WorkOrderCustomTemplateRouteData } from 'projects/ct-manager/src/app/_core/route-data/work-order-custom-template.route-data';
import { CTWorkOrderCustomTemplate } from 'projects/ct-manager/src/app/_core/classes/ct-work-order.custom-template';
import { EMPTY, lastValueFrom } from 'rxjs';

@Component({
  selector: 'ctm-work-order-edit-template',
  templateUrl: './work-order-edit-template.component.html',
  styleUrls: ['./work-order-edit-template.component.scss']
})
export class WorkOrderEditTemplateComponent implements OnInit {

  @ViewChild("TINY_EDITOR") tinyEditor?: EditorEditComponent;
  @Input() configuration!: WorkOrderEditTemplateConfiguration

  editorEnable = false;

  customTemplate: CTWorkOrderCustomTemplate | null = null;

  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("confirm")
    .setClass('ct-model-submit-button')
    .setAction(() => this.submit())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  saveButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("save")
    .setClass('ct-model-submit-button')
    .setAction(async () => await this.save())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  saveAndArchiveButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("saveAndArchive")
    .setClass('ct-model-submit-button')
    .setAction(() => this.saveAndArchive())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  deleteButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Elimina")
    .setClass('ct-model-submit-button')
    .setAction(() => this.delete())
    .setMatherialOptions(MAT_RAISED_WARN);

  constructor(private webApi: CtWebapiService, private modelService: CtModelService<any>, private cdr: ChangeDetectorRef, private snackbar: SnackbarService) { }

  ngOnInit() {

    this.getValue()

  }

  submit() {


    const request: DataRequest = new DataRequest()
      .setController([WorkOrderCustomTemplateRouteData().controller!])
      .setAction('GetTemplateHtml')
      .setQueryParams({ workOrderOid: this.configuration.WorkOrder.Oid, hideSpinner: false })
      .setResponseType("blob")
      .setMethod(MethodEnum.GET)

    this.webApi
      .request(request)
      .subscribe((result) => {

        this.setResultTemplateByBlob(result);

      });

  }


  getValue() {

    const configuration: CtModelConfiguration<any> = CtModelConfiguration.create()
      .setRouteData(WorkOrderCustomTemplateRouteData())

    const filters: CTModelDatatableFilter[] = [
      CTModelDatatableFilter
        .create()
        .setField('WorkOrder.Oid')
        .setValue(this.configuration.WorkOrder.Oid)
        .setOperatorType(CtBinaryOperator.Equal),
    ];

    const body: CtModelDatatableOperators = CtModelDatatableOperators
      .create()
      .setFilters(filters)

    this.modelService.getList(configuration, body).subscribe((result: CtWebapiGenericResponse<any>) => {

      if (result.Result.DataSource && result.Result.DataSource.length) {

        this.setResultTemplateByBase64(result.Result.DataSource[0].Content)
        this.customTemplate = result.Result.DataSource[0]
      }

    });

  }

  setResultTemplateByBlob(result: Blob | null) {

    this.editorEnable = true;

    this.HTML2String(result)
      .then((result: string | ArrayBuffer | null) => {

        const tinyConfiguration: TinyMceSetupConfiguration = TinyMceSetupConfiguration.create();
        tinyConfiguration.setInitialValue(<string>result)
        this.tinyEditor?.setup(tinyConfiguration);

      });

  }

  setResultTemplateByBase64(result: string) {

    this.editorEnable = true;
    const res = new TextDecoder().decode(Uint8Array.from(atob(result), c => c.charCodeAt(0)));
    this.cdr.detectChanges();

    setTimeout(() => {

      const tinyConfiguration: TinyMceSetupConfiguration = TinyMceSetupConfiguration.create();
      tinyConfiguration.setInitialValue(res)
      this.tinyEditor?.setup(tinyConfiguration);

    }, 500);


  }

  HTML2String(file: Blob | null): Promise<string | ArrayBuffer | null> {

    return new Promise<string | ArrayBuffer | null>((resolve) => {

      if (file) {

        const reader = new FileReader();

        reader.onload = () => resolve(reader.result);

        reader.readAsText(file);

      } else {

        resolve(null);

      }

    });

  }

  async save(): Promise<any> {

    const configuration: CtModelConfiguration<any> = CtModelConfiguration.create()
      .setRouteData(WorkOrderCustomTemplateRouteData());

    if (this.customTemplate?.Oid) {
      configuration.RouteData?.setId(this.customTemplate.Oid);
    }

    if (!this.configuration.WorkOrder?.Oid || !this.tinyEditor?.control?.value) {
      return;
    }

    const param: CTWorkOrderCustomTemplate = CTWorkOrderCustomTemplate.create()
      .setContent(btoa(String.fromCharCode(...new TextEncoder().encode(this.tinyEditor?.control.value))))
      .setWorkOrder(this.configuration.WorkOrder.Oid);

    const observable = this.modelService.putInfos(configuration, param) ?? EMPTY; // Usa EMPTY se undefined

    try {

      const result = await lastValueFrom(observable);

      if (result?.Result) {
        this.customTemplate?.setOid(result.Result);
      }

      this.snackbar.onSuccess();
      this.getValue();
      this.cdr.detectChanges();

      return result;

    } catch (error) {

      console.error('Errore durante il salvataggio:', error);
      throw error;

    }
  }

  async saveAndArchive() {

    try {
      const res = await this.save(); // Attende il completamento di save()

      const param = {

        CustomTemplateOid: this.customTemplate?.Oid ?? res.Result,

      }

      const request: DataRequest = new DataRequest()
        .setController([WorkOrderCustomTemplateRouteData().controller!])
        .setAction('SaveAndArchive')
        .setMethod(MethodEnum.POST)
        .setBody(param)

      this.webApi
        .request(request)
        .subscribe((result) => {

          this.snackbar.onSuccess();
          this.getValue();
          this.cdr.detectChanges();
          window.location.reload();
          //Qua in realtà dovrei chiamare la fetch dei documenti e portare li

        });

    } catch (error) {
      console.error('Errore durante saveAndArchive:', error);
    }

  }

  delete() {

    const configuration: CtModelConfiguration<any> = CtModelConfiguration.create()
      .setRouteData(WorkOrderCustomTemplateRouteData());

    if (!this.customTemplate?.Oid) return;

    configuration.RouteData?.setId(this.customTemplate.Oid);


    const request: DataRequest = new DataRequest()
      .setController([WorkOrderCustomTemplateRouteData().controller!, 'Delete'])
      .setAction((this.customTemplate.Oid ?? 0).toString()!);

    this.webApi
      .delete(request)
      .subscribe(() => {

        this.snackbar.onSuccess()
        this.submit();
        window.location.reload();
        this.cdr.detectChanges();

      });


  }

}
